import { OAuthProvider, signInWithPopup, updateProfile } from "firebase/auth";
import {
  initFirebase,
  clearFirebaseLocalStorage,
} from "@shared/services/api/firebase";
import { apiRequest } from "@shared/services/api/apiRequest";
import { AppType } from "@shared/types/appTypes";

export async function registerUserWithOAuth(
  appType: AppType,
  provider: OAuthProvider,
  inviteCode: string | null,
  onError?: () => void
) {
  // Determine the API endpoint based on the app type
  let apiEndpoint;

  switch (appType) {
    case "portal":
      apiEndpoint = "/api/invite/";
      break;
    case "platform":
      apiEndpoint = "/firebase-signup/";
      break;
  }

  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    // Sign in or register user with OAuth provider
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // Get user's name from the provider's data
    const firstName = user.displayName?.split(" ")[0] || "";
    const lastName = user.displayName?.split(" ").slice(1).join(" ") || "";

    // Update user profile with the parsed name
    await updateProfile(user, {
      displayName: user.displayName,
      photoURL: user.photoURL,
    });

    // Get Firebase token
    const idToken = await user.getIdToken();

    // Prepare API request body
    const body = {
      firebase_token: idToken,
      email: user.email,
      first_name: firstName,
      last_name: lastName,
      ...(inviteCode && { invite_code: inviteCode }),
    };

    // Make API call to backend
    const response = await apiRequest(apiEndpoint, "POST", body);

    return { authToken: idToken, ...response };
  } catch (error) {
    clearFirebaseLocalStorage();

    onError?.();

    throw error;
  }
}
